/* Pitch Eleven - carrossel de banners: autoplay com anel de progresso, bolinhas, pausa, arrastar. */
if (!customElements.get('pe-hero')) {
  class PeHero extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.pe-hero__track');
      this.slides = Array.from(this.querySelectorAll('.pe-hero__slide'));
      if (!this.track || this.slides.length === 0) return;

      this.index = 0;
      this.delay = (parseInt(this.dataset.speed, 10) || 5) * 1000;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.wantsAutoplay = this.dataset.autoplay === 'true' && this.slides.length > 1 && !this.reduced;

      this.onBlockSelect = this.onBlockSelect.bind(this);
      this.onBlockDeselect = this.onBlockDeselect.bind(this);
      this.onVisibility = this.onVisibility.bind(this);

      this.querySelectorAll('[data-go]').forEach((btn) =>
        btn.addEventListener('click', () => {
          this.goTo(parseInt(btn.dataset.go, 10));
          if (!this.classList.contains('is-paused')) this.schedule();
        })
      );

      this.querySelectorAll('[data-pe-hero-toggle]').forEach((btn) =>
        btn.addEventListener('click', () => (this.classList.contains('is-paused') ? this.play() : this.pause()))
      );

      this.onTrackScroll = this.onTrackScroll.bind(this);
      this.track.addEventListener('scroll', this.onTrackScroll, { passive: true });

      this.track.addEventListener('pointerdown', () => this.userInteracted(), { passive: true });
      this.track.addEventListener('touchstart', () => this.userInteracted(), { passive: true });

      document.addEventListener('shopify:block:select', this.onBlockSelect);
      document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
      document.addEventListener('visibilitychange', this.onVisibility);

      if (this.wantsAutoplay) this.play();
      else this.pause(true);
    }

    disconnectedCallback() {
      window.clearTimeout(this.timer);
      window.clearTimeout(this.scrollTimer);
      this.track?.removeEventListener('scroll', this.onTrackScroll);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      document.removeEventListener('visibilitychange', this.onVisibility);
    }

    onTrackScroll() {
      window.clearTimeout(this.scrollTimer);
      this.scrollTimer = window.setTimeout(() => {
        const largura = this.track.clientWidth || 1;
        this.setActive(Math.round(this.track.scrollLeft / largura));
      }, 80);
    }

    setActive(i) {
      if (i < 0 || i >= this.slides.length || i === this.index) return;
      this.index = i;
      this.slides.forEach((slide, n) => slide.classList.toggle('is-active', n === i));
      this.querySelectorAll('.pe-hero__dot').forEach((dot) => {
        const atual = parseInt(dot.dataset.go, 10) === i;
        dot.classList.remove('is-current');
        if (atual) {
          void dot.offsetWidth; // reinicia a animacao do anel
          dot.classList.add('is-current');
        }
      });
      if (!this.classList.contains('is-paused')) this.schedule();
    }

    goTo(i) {
      const total = this.slides.length;
      const alvo = ((i % total) + total) % total;
      this.track.scrollTo({ left: this.slides[alvo].offsetLeft, behavior: this.reduced ? 'auto' : 'smooth' });
      this.setActive(alvo);
    }

    schedule() {
      window.clearTimeout(this.timer);
      if (this.slides.length < 2) return;
      this.timer = window.setTimeout(() => this.goTo(this.index + 1), this.delay);
    }

    play() {
      this.classList.remove('is-paused');
      this.classList.add('is-playing');
      this.querySelectorAll('[data-pe-hero-toggle]').forEach((b) => b.setAttribute('aria-label', 'Pause'));
      this.querySelectorAll('.pe-hero__dot.is-current').forEach((d) => {
        d.classList.remove('is-current');
        void d.offsetWidth;
        d.classList.add('is-current');
      });
      this.schedule();
    }

    pause(silencioso) {
      window.clearTimeout(this.timer);
      this.classList.add('is-paused');
      if (silencioso) this.classList.remove('is-playing');
      this.querySelectorAll('[data-pe-hero-toggle]').forEach((b) => b.setAttribute('aria-label', 'Play'));
    }

    userInteracted() {
      if (!this.classList.contains('is-paused')) this.schedule();
    }

    onVisibility() {
      if (document.hidden) window.clearTimeout(this.timer);
      else if (!this.classList.contains('is-paused')) this.schedule();
    }

    onBlockSelect(event) {
      const slide = event.target.closest?.('.pe-hero__slide');
      if (!slide || !this.contains(slide)) return;
      this.pause();
      this.goTo(this.slides.indexOf(slide));
    }

    onBlockDeselect(event) {
      if (this.contains(event.target) && this.wantsAutoplay) this.play();
    }
  }

  customElements.define('pe-hero', PeHero);
}
